import {
    API,
    graphqlOperation
} from "aws-amplify";
import {
    SubmitQuickQuoteInput,
    SubmitQuickQuoteMutation,
    SubmitQuickQuoteMutationVariables
} from "../../../API";

import { AuthIDTokenSupplierFactory } from "../../auth/AuthIDTokenSupplierFactory";
import ClientLogger from "../../logging/ClientLogger";
import ClientLoggerFactory from "../../logging/ClientLoggerFactory";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { IDTokenSupplier } from "../../auth/IDTokenSupplier";
import { SubmitQuickQuoteClient } from "./SubmitQuickQuoteClient";
import { submitQuickQuote } from "../../../graphql/mutations";
import uuidv4 from "../../util/UuidGenerator";

export class GraphQLQuickQuoteClient implements SubmitQuickQuoteClient {
    private static readonly CREATE_ATTEMPT_METRIC_NAME = "GraphQLQuickQuoteDAO.Submit.Attempt";
    private static readonly CREATE_FAILURE_METRIC_NAME = "GraphQLQuickQuoteDAO.Submit.Error";
    private readonly idTokenSupplier: IDTokenSupplier;
    private logger: ClientLogger;
    constructor(
        logger: ClientLogger,
        idTokenSupplier: IDTokenSupplier
    ) {
        this.logger = logger;
        this.idTokenSupplier = idTokenSupplier;
    }
    public async submitQuickQuote(quickQuotes: SubmitQuickQuoteInput[]): Promise<string> {
        this.logger.info(
            `Creating Quick Quote for issue with id=${quickQuotes.map((quickQuote) => quickQuote.issueId)}`,
            quickQuotes[0],
            [GraphQLQuickQuoteClient.CREATE_ATTEMPT_METRIC_NAME]
        );
        try {
            const authToken: string = await this.idTokenSupplier.get();
            const executionId: string = uuidv4();
            const variables: SubmitQuickQuoteMutationVariables = {
                input: quickQuotes,
                executionId
            };
            const result: GraphQLResult<SubmitQuickQuoteMutation> = await API.graphql(
                graphqlOperation(
                    submitQuickQuote,
                    variables,
                    authToken
                )
            ) as GraphQLResult<SubmitQuickQuoteMutation>;
            return result.data?.submitQuickQuote?.status ?? "";
        } catch (error) {
            const errorMessage = `Unable to quick quote for issue with id=${quickQuotes.map((quickQuote) => quickQuote.issueId)}`;
            this.logger.error(
                errorMessage,
                error,
                [GraphQLQuickQuoteClient.CREATE_FAILURE_METRIC_NAME]
            );
            throw new Error(errorMessage);
        }

    }
}
export const graphQLQuickQuoteClient = new GraphQLQuickQuoteClient(ClientLoggerFactory.getClientLogger("GraphQLIssueDAO"), AuthIDTokenSupplierFactory.getInstance());